<template>
  <div class="stats-dash-list">
   <div class="row">
     <div class="col s12 l11 no-float center-aligned">
       <div class="card">

         <div class="card-content">
            <search-bar @search="searchField = $event"/>
            <div class="original" v-if="searchField === ''">
              <table v-for="(category, index) in postsByCategory" :key="category.id">
                    <thead>
                      <tr v-if="index === 0">
                        <th>
                          Author
                        </th>
                        <th>
                          Created
                        </th>
                        <th>Country</th>
                        <th>
                          Status
                        </th>
                      </tr>
                      <tr>
                        <th colspan="4">
                          <span v-html="category.name"></span>
                          <button @click="getCsv(index)" class="btn waves-efffect rounded right">Download</button>
                        </th>
                      </tr>
              
                    </thead>
                    <tbody >
                      <tr v-for="item in category.posts" :key="item.id">
                        <td>
                          <!-- <router-link 
                            :to="{
                                name:'statFormView', 
                                params:{
                                  id:item.id, 
                                  userId: item.author, 
                                  categoryId: item.categories[0]
                                  },
                                  query:{
                                    view:'no-edit'
                                  }
                                }">
                          </router-link> -->
                          <a :href="`/stats/form/${item.id}/${item.author}/${item.categories[0]}?view=no-edit`">
                          
                            {{$_getUser(item.author)}} - {{item.acf.period.term.replaceAll('0', '')}}</a>
                        </td>
                        <td>{{dateFormat(new Date(item.date), 'ddd MMM Do YYYY')}}</td>
                        <td style="text-transform: capitalize">{{item.acf.country.label}}</td>
                      
                        <td style="text-transform: capitalize">{{item.acf.status}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="filtered" v-else>
                  <table>
                    <thead>
                      <tr >
                        <th>
                          Author
                        </th>
                        <th>
                          Created
                        </th>
                        <th>Country</th>
                        <th>
                          Status
                        </th>
                      </tr>
              
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in itemsX" :key="index">
                        <td>
                          <router-link 
                            :to="{
                                name:'statFormView', 
                                params:{
                                  id:item.id, 
                                  userId: item.author, 
                                  categoryId: item.category
                                  },
                                  query:{
                                    view:'no-edit'
                                  }
                                }">
                                {{item.Person}} - {{item.category === 177 ? 'Criminal' : 'Civil'}}
                            </router-link>
                          
                        </td>
                        <td>
                          {{item.Created}}
                        </td>
                        <td>
                          {{item.Country}}
                        </td>
                        <td style="text-transform: capitalize">
                          {{item.Status}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
         </div>
       </div>
   
     </div>
   </div>
    
  </div>
</template>
<script>
import searchBar from '@/components/searchField.component.vue'
import criminal from './criminalForm.js'
import civil from './civilForm.js'
import {dateFormat} from '@/functions.js'
import {mapState} from 'vuex'
import {getAllMySubmissions, getAppUsers, getStatsCategories} from '@/services/contentService.js'

export default {
  name:'statsDashboard',
  components:{
    searchBar
  },
  data () {
    return {
      searchField: '',
      items:[],
      categories:[],
      criminal,
      civil,
    }
  },
  async mounted() {
    await this.getAppUsers()
    await this.getStatsCategories()
    let {data} =  await getAllMySubmissions()
    this.items = data
  },
  computed:{
    ...mapState({
      staff: state => state.staff,
    }),
    groupPersonExport (){
    return this.categories.map(({name, id}) =>{
      return {
        name, id,
        persons: this.postsByCategory
/*         persons:this.criminal.fields.filter((x) => {
          return x.name.includes('_label') 
        }).map((doc) => {
          let xAnsewers = []
          this.postsByCategory[0].export.forEach((entry) =>{
            let value = {}
              value[doc.name] = entry[doc.label]
              xAnsewers.push(value)
            })
          return {
            ...doc,
            answers: xAnsewers
          }
        })  */
      }
  })
    },
    postsByCategory () {
      return this.categories.map(({name, id}, index) =>{
        let x = this.items.filter(post => post.categories.includes(id))
            .sort((a,b) =>  a.acf.country.label.localeCompare(b.acf.country.label))
        return {
          name, id,
          posts: x,
          export: x.map(({acf, author})=> {
          let exportSchema = id === 177 ? this.criminal.exportSchema :  this.civil.exportSchema
           return this.postForCSV(acf, exportSchema, id,  author)
          })
        }
      })
    },
    itemsX () {
      // eslint-disable-next-line no-unused-vars
      return this.items.map(({id, acf,categories,date, author}) => {
 
        let person = this.staff.findIndex(({id}) => author === id )
     /*    let toObj = JSON.parse(acf.json_string) */
        let value = {}
        value['Person'] = this.staff[person].first_name+' '+this.staff[person].last_name
        value['Country'] = acf.country.label
        value['Created'] = dateFormat(new Date(date), 'ddd MMM Do YYYY')
        value['Status'] = acf.status
        value['category'] = categories[0]
        value['id'] = id
        value['author'] = author
   /*       Object.keys(toObj).forEach((key) => {
          if(Array.isArray(toObj[key])){
              value[this.getFieldLabel(categories[0], key)] = toObj[key].map(he => {
                return `${he.reason}:${he.total} `
              }).toString()
          } else {
             value[this.getFieldLabel(categories[0], key)] = toObj[key]
          }
        }) */
        return {
          ...value,
        }
      })
    .filter(({Person, Country}) => `${Person} ${Country}`.toLowerCase().trim().includes(this.searchField.toLowerCase().trim()))
    }
  },
  methods:{
    htmlFieldCheck(e, key, id){ 
  
      if(id === 177)  {
        let fieldType = this.criminal.fields.find(({name})=> name === key)
       if(fieldType.type === 'text_area') {
          let div = document.createElement('div')
          div.innerHTML = e.replaceAll('</p>', ' ')
          return div.textContent.replace(/[^a-zA-Z0-9 --:-;]/g, "");
       } else return e
      } else {
        let fieldType = this.civil.fields.find(({name})=> name === key)
        if(fieldType.type === 'text_area') {
          let div = document.createElement('div')
          div.innerHTML = e.replaceAll('</p>', ' ')
          return div.textContent.replace(/[^a-zA-Z0-9 --:-;]/g, "");
        } else   return e
      }
    
    },
    arrToObj (arr) {
      if(!arr || !arr.length) return 
      let x = {}
      arr.forEach(item => {
        x[item.key] = item.value
      })
      return x
    },
    postForCSV (post, form, id, author) {
     
      if(!post.formfields) return
      let obj = {}
      post.formfields.forEach(field => {
        obj[field.key] = field.value
      })
      let newObj = {}
      Object.keys(form).forEach((key)=>{
        if(obj[key]) newObj[form[key].label] = this.htmlFieldCheck(obj[key], key, id)
        else newObj[form[key].label]  = ''
      })

 
  let person = this.staff.findIndex(({id}) => author === id )

     /*    let toObj = JSON.parse(acf.json_string) */
        let value = {}
        value['User'] = this.staff[person].first_name+' '+this.staff[person].last_name
      // value['Country'] = acf.country.label
   
      return {...value, ...newObj}
    },
    getFieldLabel (cat, key) {
      const textContent = (e) => {
        let div = document.createElement('DIV')
        div.innerHTML = e.replaceAll('&nbsp;', '')
        return div.textContent
      }
      if (cat === 177) {
       
        let record = this.criminal.fields.findIndex(({name}) => name === `${key}_label`)
        // console.log(this.criminal.fields[record].label)
        if(record > -1) return `${textContent(this.criminal.fields[record].label)}`//return this.criminal.fields[record].label
       
      }
      else  {
      
        let record = this.civil.fields.findIndex(({name}) => name === `${key}_label`)
        if(record > -1) return `${textContent(this.civil.fields[record].label)}`//return this.civil.fields[record].label
     
      }
      
    },
    getCsv (index){
      let list = this.postsByCategory[index].export.filter(x => x)
    let items = this.$papa.unparse(list, {  delimiter: ","  })

   
      this.$papa.download(items, `${this.postsByCategory[index].name}`+ dateFormat(new Date(), 'DD MMM YYYY hh:mm'))    
    },
    async getStatsCategories () {
      let {data} = await getStatsCategories()
      this.categories = data
    },
    async getAppUsers() {
      let {data} = await getAppUsers()
      this.$store.commit('SET_STAFF_LISTS', data)
      return data
    },
    $_getUser (x){
      let record = this.staff.findIndex(user => user.id === x)
      if(record > -1)   return this.staff[record].first_name +' '+ this.staff[record].last_name 
      else return 'No One'
    },
    dateFormat,
  }
}
</script>
<style scoped lang="scss">
.stats-dash-list {
    width: calc(100% - 300px);
    margin-left: 300px;
    padding: 16px;
 }
</style>